import { Injectable } from '@angular/core';

import { ValidationResult } from '../models/validation-result.model';

@Injectable({
    providedIn: 'root'
})
export class CifValidatorService {

    public  cifRegexPattern        : RegExp = /^([ABCDEFGHJKLMNPQRSUVW]{1})([0-9]{7})([0-9A-J]{1})$/;
    private cifControlLettersDigit : RegExp = /^[ABEH]$/;
    private cifControlLettersLetter: RegExp = /^[KPQS]$/;
    private cifControlLetters      : string = "JABCDEFGHI";

    private formatErrorMessage: string = 'El formato del CIF es incorrecto';
    private validErrorMessage : string = 'CIF no válido';

    constructor() { }

    public validate(cif: string) : ValidationResult {

        let validationResult = new ValidationResult();

        if (!this.cifRegexPattern.test(cif)) {

            validationResult.setInvalidResult(this.formatErrorMessage);
            return validationResult;

        }

        let match = cif.match(this.cifRegexPattern);

        let letter : string = match[1];
        let number : string = match[2];
        let control: string = match[3];

        let evenSum = 0;
        let oddSum  = 0;
        let n;

        // Odd positions (Even index equals to odd position. i = 0 equals first position).
        // Odd positions are multiplied first. If the multiplication is bigger than 10 we need to adjust.
        // Even positions: just sum them.
        for (var i = 0; i < number.length; i++) {

            n = parseInt(number[i], 10);
            if (i % 2 === 0) {
                n = n * 2;
                oddSum = oddSum + (n < 10 ? n : n - 9);
            } else {
                evenSum = evenSum + n;
            }

        }

        let oddEvenSum   : number = evenSum + oddSum;
        let oddEvenDigit : number = +(oddEvenSum.toString().substring(1));
        let controlDigit : number = oddEvenDigit == 0 ? 0 : (10 - oddEvenDigit);
        let controlLetter: string = this.cifControlLetters.substring(controlDigit, 1);

        let isValidated: boolean = false;
        // Control must be a digit.
        if (letter.match(this.cifControlLettersDigit)) {
            isValidated = control == controlDigit.toString();

        // Control must be a letter.
        } else if (letter.match(this.cifControlLettersLetter)) {
            isValidated = control == controlLetter;

        // Can be either.
        } else {
            isValidated = control == controlDigit.toString() || control == controlLetter;
        }

        isValidated ?
            validationResult.setValidResult() :
            validationResult.setInvalidResult(this.validErrorMessage);

        return validationResult;

    }

}
